const EXPANDED_CLASS = 'is-expanded'

const getHeader = () => document.querySelector('header')

const isMenuExpanded = () => {
  const header = getHeader()

  if (!header) {
    return false
  }

  return header.classList.contains(EXPANDED_CLASS)
}

const collapseMenu = () => {
  const header = getHeader()

  if (!header) {
    return
  }

  header.classList.remove(EXPANDED_CLASS)
}

const expandMenu = () => {
  const header = getHeader()

  if (!header) {
    return
  }

  header.classList.add(EXPANDED_CLASS)
}

const toggleMenu = () => {
  const body = document.querySelector('body')
  if (isMenuExpanded()) {
    body.classList.remove('menu-open')

    // Close all submenus
    let topLevelMenu = document.getElementById('mobile-menu-main-menu')
    topLevelMenu.classList.remove('submenu-open')

    let menuItems = document.querySelectorAll('.menu-item-has-children')
    menuItems.forEach(function (item) {
      item.classList.remove('active')

      let submenu = item.nextElementSibling

      if (submenu) {
        submenu.classList.remove('active')
      }
    })
    // Close menu
    return collapseMenu()
  }
  body.classList.add('menu-open')
  expandMenu()
}

const initMenu = () => {
  // Desktop menu - use matchMedia to properly detect viewport width
  const isDesktop = window.matchMedia('(min-width: 1165px)').matches

  if (isDesktop) {
    const dropdonLinks = Array.from(
      document.querySelectorAll('.menu-item-has-children')
    )

    dropdonLinks.forEach(link => {
      let closeTimeout = null

      link.addEventListener('mouseenter', e => {
        // Clear any pending close timeout for this link
        if (closeTimeout) {
          clearTimeout(closeTimeout)
          closeTimeout = null
        }

        // Remove active class from all other links
        dropdonLinks.forEach(otherLink => {
          if (otherLink !== link) {
            otherLink.classList.remove('js-dropdown-active')
          }
        })

        e.currentTarget.classList.add('js-dropdown-active')
        expandMenu()
      })

      link.addEventListener('mouseleave', e => {
        const targetElement = e.currentTarget

        // Add a small delay before closing to prevent premature closing
        closeTimeout = setTimeout(() => {
          targetElement.classList.remove('js-dropdown-active')
          collapseMenu()
          closeTimeout = null
        }, 100)
      })
    })
  }

  // Mobile menu
  document.getElementById('mobile-menu-burger').addEventListener('click', e => {
    e.preventDefault()
    toggleMenu()
  })

  let childrenMenuItems = document.querySelectorAll(
    '#mobile-menu-main-menu > .menu-item-has-children'
  )

  childrenMenuItems.forEach(function (item) {
    item.querySelector('a').addEventListener('click', function (event) {
      event.preventDefault()
      childrenMenuItems.forEach(function (elem) {
        elem.classList.remove('active')
      })

      item.classList.toggle('active')

      let topLevelMenu = document.getElementById('mobile-menu-main-menu')
      let submenu = item.nextElementSibling
      if (submenu && submenu.classList.contains('mobile-submenu')) {
        topLevelMenu.classList.toggle('submenu-open')
        submenu.classList.toggle('active')
      }
    })
  })

  const childrenSubmenuItems = document.querySelectorAll(
    '.mobile-submenu .menu-item-has-children'
  )

  childrenSubmenuItems.forEach(function (item) {
    item.querySelector('a').addEventListener('click', function (event) {
      event.preventDefault()
      childrenSubmenuItems.forEach(elem => {
        elem.classList.remove('active')
      })
      item.classList.toggle('active')
      let subSubmenu = item.nextElementSibling
      if (subSubmenu && subSubmenu.classList.contains('mobile-sub-submenu')) {
        document.querySelectorAll('.mobile-sub-submenu').forEach(elem => {
          elem.classList.remove('active')
        })
        subSubmenu.classList.toggle('active')
      }
    })
  })
}

document.addEventListener('DOMContentLoaded', initMenu)
